import { DataPage } from '@/app.routes';
import { UserHelper } from '@/helpers/user.helper';
import { AppConfigService } from '@/services/app-config.service';
import { AuthenticationService } from '@/services/authentication.service';
import { MenuToNativeId } from '@/services/bridge/bridge.service';
import { NavService } from '@/services/nav.service';
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { SupportType } from '@eemo/api-client';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-help-scout-widget',
  imports: [],
  templateUrl: './help-scout-widget.component.html',
  styleUrl: './help-scout-widget.component.scss',
})
export class HelpScoutWidgetComponent implements OnInit, OnDestroy {
  private userHelper = inject(UserHelper);
  private authenticationService = inject(AuthenticationService);
  private appConfigService = inject(AppConfigService);
  private navService = inject(NavService);

  subs: Subscription[] = [];

  /** closes the beacon when the user clicks outside of it (clicks inside its iframes never reach the document) */
  private closeBeaconOnOutsideClick = (event: MouseEvent) => {
    if (!(event.target as Element)?.closest?.('#beacon-container, [class*="Beacon"]')) {
      window['Beacon']('close');
    }
  };

  ngOnInit() {
    if (this.appConfigService.isMobileOrTablet) {
      // on mobile or table the beacon is inited only on the help page
      this.subs.push(
        this.navService.currentDataPage$.subscribe((data: DataPage) => {
          if (data && MenuToNativeId.HELP === data.page) {
            this.loadBeacon();
          } else {
            this.destroyBeacon();
          }
        }),
      );
    } else {
      // load beacon
      this.loadBeacon();
    }
  }

  loadBeacon() {
    if (this.appConfigService.isDemo()) {
      return;
    }
    const Beacon = window['Beacon'];
    this.subs.push(
      this.authenticationService.currentUser.subscribe((session) => {
        if (session && session.supportType !== SupportType.NONE) {
          Beacon('init', session.supportId);
          Beacon('identify', {
            name: this.userHelper.displayName,
            email: this.userHelper.email,
            signature: session.supportToken,
            app_role: session.role,
            app_account_type: session.accountType,
            app_subscription_state: session.subscriptionState,
          });
          const beaconConfig = {
            display: {
              style: 'iconAndText',
              iconImage: 'message',
              position: 'left',
              text: "Besoin d'aide ?",
            },
          };
          if (this.appConfigService.isMobileOrTablet) {
            //beaconConfig.display.iconImage = 'question';
            beaconConfig.display.text = 'En quoi pouvons-nous vous aider ? ';
          }
          Beacon('config', beaconConfig);
          Beacon('on', 'open', () => document.addEventListener('click', this.closeBeaconOnOutsideClick, true));
          Beacon('on', 'close', () => document.removeEventListener('click', this.closeBeaconOnOutsideClick, true));
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.destroyBeacon();
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  destroyBeacon() {
    document.removeEventListener('click', this.closeBeaconOnOutsideClick, true);
    if (window['Beacon']('info')) window['Beacon']('destroy');
  }
}
